module.exports = __webpack_public_path__ + "img/Ellipse9.abc06216.png";